// extracted by mini-css-extract-plugin
export default {"waiting":"WaitingSteps_waiting__IeoRJ","orange":"WaitingSteps_orange__oXoVL"};